import { render } from "./listsCoupon.vue?vue&type=template&id=3c0298b8&scoped=true&ts=true"
import script from "./listsCoupon.vue?vue&type=script&lang=ts"
export * from "./listsCoupon.vue?vue&type=script&lang=ts"

import "./listsCoupon.vue?vue&type=style&index=0&id=3c0298b8&scoped=true&lang=css"

import exportComponent from "/builds/psj7085139/sam/samva-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0298b8"]])

export default __exports__